import cxs from 'cxs';

export const LOCATION_SELECTOR__ROOT = cxs({
  width: '100%'
});

export const MANUAL_LOCATION_LINK = cxs({
  ' .text--link': {
    fontSize: '12px'
  }
});